import script from "./DTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DTable.vue?vue&type=script&setup=true&lang=js"

import "./DTable.vue?vue&type=style&index=0&id=778762fc&lang=css"
import "./DTable.vue?vue&type=style&index=1&id=778762fc&lang=scss"

const __exports__ = script;

export default __exports__